/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackDefaultVerySad = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackDefaultVerySad"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_10198_387)">
      <path
        fill="var(--xdlColorIllustrationOutlineSecondary)"
        d="M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M14.62 19.8c-2.24 0-4.25.99-5.61 2.56a7.4 7.4 0 0 0 5.61 2.56c2.24 0 4.25-.99 5.61-2.56a7.4 7.4 0 0 0-5.61-2.56M27.71 19.8c-2.24 0-4.25.99-5.61 2.56a7.4 7.4 0 0 0 5.61 2.56c2.24 0 4.25-.99 5.61-2.56a7.42 7.42 0 0 0-5.61-2.56"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="M41 21C41 9.954 32.046 1 21 1S1 9.954 1 21s8.954 20 20 20v1C9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21-9.402 21-21 21v-1c11.046 0 20-8.954 20-20"
      />
      <path
        fill="#1D2124"
        d="M17.81 19.98c.6.09 1.2.16 1.81.17l.02-1c-3.33-.06-6.46-1.4-8.82-3.75l-.71.71c1.47 1.47 3.23 2.56 5.14 3.24q-.315-.03-.63-.03c-2.39 0-4.53 1.06-5.99 2.73l-.28.33.28.33a7.9 7.9 0 0 0 5.99 2.73c2.39 0 4.53-1.06 5.99-2.73l.29-.33-.29-.33a7.8 7.8 0 0 0-2.8-2.05zm-3.19 4.44c-.81 0-1.58-.14-2.3-.39.67-.26 1.14-.91 1.14-1.67s-.47-1.41-1.14-1.67c.72-.25 1.49-.39 2.3-.39 1.93 0 3.67.79 4.93 2.06a6.92 6.92 0 0 1-4.93 2.06M33.7 22.03a7.94 7.94 0 0 0-5.99-2.73c-.21 0-.42.02-.63.03 1.91-.68 3.67-1.77 5.14-3.24l-.71-.71a12.73 12.73 0 0 1-8.82 3.75l.02 1c.61-.01 1.22-.08 1.81-.17a8 8 0 0 0-2.8 2.06l-.29.33.28.33a7.936 7.936 0 0 0 11.98 0l.28-.33-.28-.33zm-5.99 2.39c-.81 0-1.58-.14-2.3-.39a1.785 1.785 0 0 0-.01-3.33c.72-.25 1.49-.39 2.3-.39 1.93 0 3.67.79 4.93 2.06a6.92 6.92 0 0 1-4.93 2.06zM27.05 29.8c-3.28-3.28-8.61-3.28-11.88 0l-.71-.71a9.33 9.33 0 0 1 6.65-2.75c2.51 0 4.87.98 6.65 2.75z"
      />
    </g>
    <defs>
      <clipPath id="clip0_10198_387">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackDefaultVerySad;
